/**
 * Pseudo cliquable ouvrant la fiche joueur.
 *
 * Wrapper inline qui rend un pseudo interactif.
 * Quand disabled=true, le clic est ignoré (utile quand une autre action
 * est attachée au pseudo, comme inviter ou placer un joueur).
 */

import { useProfile } from '../contexts/ProfileContext';
import '../styles/profile-modal.css';

interface ClickablePseudoProps {
  pseudo: string;
  children?: React.ReactNode;
  className?: string;
  disabled?: boolean;
}

export default function ClickablePseudo({ pseudo, children, className = '', disabled }: ClickablePseudoProps) {
  const { openPlayerProfile } = useProfile();

  if (disabled) {
    return <span className={className}>{children ?? pseudo}</span>;
  }

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    openPlayerProfile(pseudo);
  };

  return (
    <span
      className={`clickable-pseudo ${className}`}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter') openPlayerProfile(pseudo); }}
    >
      {children ?? pseudo}
    </span>
  );
}
